import React, {useState} from "react";
import axios from "axios";
import {List, ListItem, Box, Button, Typography} from '@mui/material/';
import TextInput from "../components/TextInput";
import Dropdown from '../components/Dropdown';
import countryCodes from "./../json/countryCodes.json"
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";
const PhoneAndName = () => {
    const [error, setError] = useState('')
    const [data, setData] = useState({"fname": "", "lname": "", "phone": ""})
    const validationSchema = Yup.object().shape({
        fname: Yup.string().required('(This question is required)'),
        lname: Yup.string().required('(This question is required)'),
        countryCode: Yup.string().required('(This question is required)'),
        phone: Yup.number("Numbers only").required('(This question is required)'),
    });
    const { control, handleSubmit, formState: { errors }, setValue} = useForm({ resolver: yupResolver(validationSchema), shouldFocusError: true});

    let location = window.location.href
    location = location.replace('/#', '')
    let status = new URL(location).searchParams.get('status')

    const submitData = (data) => {
        let mergedData = {
            "fname": data.fname,
            "lname": data.lname,
            "phone": "+" + data.countryCode.split("+")[1] + data.phone
        }
        axios.post(constants.serverURL + "submitPhoneAndName", mergedData,
            {
                withCredentials: true
            }).then(response => {
            localStorage.setItem('phoneAndName', JSON.stringify(mergedData))
            window.location.href = constants.websiteURL + '#/phoneverify'
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=phone'
            } else {
                setError(error.request.responseText)
            }
        })
    }


    return (
        <div>
            <MenuAppBar title="" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                    <h1>Hello, new {status}!</h1>
                <List>
                    {
                        error &&
                        <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <Typography className="font-16 error-message">{error}</Typography>
                        </ListItem>
                    }
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <TextInput
                            name={"fname"}
                            control={control}
                            question={"First Name"}
                            required={true}
                            errors={errors.fname}
                        />
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <TextInput
                            name={"lname"}
                            control={control}
                            question={"Last Name"}
                            required={true}
                            errors={errors.lname}
                        />
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Dropdown
                            name={"countryCode"}
                            control={control}
                            question={"Country Code"}
                            options={Object.keys(countryCodes).map(function(code) {return countryCodes[code].name + " " + countryCodes[code].dial_code})}
                            label={"Select an option"}
                            required={true}
                            errors={errors.countryCode}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <TextInput
                            name={"phone"}
                            control={control}
                            question={"Phone Number"}
                            required={true}
                            errors={errors.phone}
                        />
                    </ListItem>
                    <Button className="m-form-button" variant="outlined" onClick={handleSubmit(submitData)}>Submit</Button>
                </List>
                </Box>
            </form>
        </div>
    );
};

export default PhoneAndName;